import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-boton-secundario-consulta',
  templateUrl: './boton-secundario-consulta.component.html',
  styleUrls: ['./boton-secundario-consulta.component.scss']
})
export class BotonSecundarioConsultaComponent {
  @Input() boton_texto: string;
  @Output("boton_funcion") boton_funcion: EventEmitter<any> = new EventEmitter<any>();
  @Input() disabled: boolean = false;

  ejecutarFuncion() {
    this.boton_funcion.emit();
  }
}
